var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgListMark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_28369_22790)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.1917 5.46466C21.3792 5.65219 21.4845 5.9065 21.4845 6.17166C21.4845 6.43683 21.3792 6.69113 21.1917 6.87866L9.9497 18.1217C9.84755 18.2239 9.72627 18.3049 9.59278 18.3602C9.45928 18.4156 9.3162 18.444 9.1717 18.444C9.02721 18.444 8.88413 18.4156 8.75063 18.3602C8.61714 18.3049 8.49586 18.2239 8.3937 18.1217L2.8077 12.5357C2.71479 12.4428 2.64109 12.3325 2.59081 12.2111C2.54053 12.0897 2.51465 11.9596 2.51465 11.8282C2.51465 11.6968 2.54053 11.5667 2.59081 11.4453C2.64109 11.3239 2.71479 11.2136 2.8077 11.1207C2.90061 11.0278 3.01092 10.9541 3.13231 10.9038C3.2537 10.8535 3.38381 10.8276 3.5152 10.8276C3.6466 10.8276 3.77671 10.8535 3.8981 10.9038C4.01949 10.9541 4.12979 11.0278 4.2227 11.1207L9.1727 16.0707L19.7767 5.46466C19.9642 5.27719 20.2185 5.17188 20.4837 5.17188C20.7489 5.17188 21.0042 5.27719 21.1917 5.46466Z",
    fill: "#1E1D24"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_28369_22790"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListMark);
export default __webpack_public_path__ + "static/media/list-mark.401bacc6430cebe5450d06061021235a.svg";
export { ForwardRef as ReactComponent };